import { useContext } from 'react';
import CustomerForm from '../../../ui-components/customer-form/CustomerForm';
import { giftcardState } from '../client-state/giftcard-state-context';
import useGiftcardTracking from '../../../Hooks/use-giftcard-tracking';
import { giftcardStepDependencies } from '..';
import { customerReducerActionTypes } from '../../../redusers/customer-reducer';
import useGiftcardMinimalShop from '../server-data/use-giftcard-minimal-shop';
import useGiftcardChangeStep from '../../../Hooks/use-giftcard-change-step';

const CustomerFormWithData = () => {
  const { data: minimalShop } = useGiftcardMinimalShop();
  const { state, dispatch } = useContext(giftcardState);
  const track = useGiftcardTracking();
  const changeStep = useGiftcardChangeStep(giftcardStepDependencies);

  return (
    <CustomerForm
      customer={state.customer.customer}
      onChange={(event, country) => {
        dispatch({
          type: customerReducerActionTypes.UPDATE_CUSTOMER,
          payload: {
            ...state.customer.customer,
            [event.target.name]: event.target.value,
            ...(country && { address: { country: country } }),
          },
        });
      }}
      onFormValid={(formValid) => {
        dispatch({
          type: customerReducerActionTypes.UPDATE_FORM_VALID,
          payload: formValid,
        });
        if (formValid) {
          track({
            type: 'CHECKOUT_GIFTCARD',
            product: state.giftcard,
            step: 1,
          });
        }
      }}
      onSubmit={() => changeStep(3)}
      errors={{ customerForm: state.errors.customerForm ?? '' }}
      shopCountry={minimalShop?.country}
    />
  );
};

export default CustomerFormWithData;
